export default __webpack_public_path__ + "static/media/userGroups_icon.30a9dbf9.svg";